export default __webpack_public_path__ + "static/media/news26.085838a8.jpg";